function getCurrencyDecimalDigits(currency="AED") {
  if (typeof currency === "string") {
    if (currency.toUpperCase() === "BHD") 
      return 3;
    return 2;
  }
  return 2;
}

export const CurrencyFormatterPlugin = {
  install(Vue) {
    Vue.prototype.$getCurrencyDecimalDigits = getCurrencyDecimalDigits;

    Vue.prototype.$formatCurrency = function (amount, currency) {
      const formattedAmount = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency || "AED",
        currencyDisplay: "code",
        trailingZeroDisplay: "stripIfInteger",
        maximumFractionDigits: getCurrencyDecimalDigits(currency),
      }).format(amount);

      let splitAmount = formattedAmount.split(".");
      return splitAmount[1] > 0 ? formattedAmount : splitAmount[0];
      // return formattedAmount;
    };

    Vue.prototype.$formatThousandsSeparator = function (amount) {
      const formattedAmount = new Intl.NumberFormat("en-US", {
        maximumFractionDigits: 2,
      }).format(amount);

      let splitAmount = formattedAmount.split(".");
      return splitAmount[1] > 0 ? formattedAmount : splitAmount[0];
    };

    Vue.prototype.$formatTableCurrency = function (amount, currency) {
      const formattedAmount = new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: getCurrencyDecimalDigits(currency),
        maximumFractionDigits: getCurrencyDecimalDigits(currency),
      }).format(amount);

      return `
        ${formattedAmount}<span style="vertical-align: top; font-size: 10px; font-weight: 500; color: #a4a4a4; margin-left: 3px;">${currency}</span>
      `;
    };

    Vue.prototype.$formatCardCurrency = function (amount, currency) {
      const formattedAmount = new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: getCurrencyDecimalDigits(currency),
        maximumFractionDigits: getCurrencyDecimalDigits(currency),
      }).format(amount);

      return `
        <strong>${formattedAmount}</strong><span style="vertical-align: top; font-size: 10px; font-weight: 700; color: #a4a4a4; margin-left: 3px;">${currency}</span>
      `;
    };
  },
};
